// extracted by mini-css-extract-plugin
export default {"texto":"UsoDoEspaco_texto__5BpoQ","cheio":"UsoDoEspaco_cheio__9SFPM"};